var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconEyeClose = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeWidth: "2.167", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(0.449 0.449)" },
                React.createElement("path", { d: "M21,21c-1.9,1.4-4.1,2.2-6.4,2.2c-7.6,0-11.9-8.7-11.9-8.7C4,12,5.9,9.8,8.1,8.1 M12.3,6.1\n\t\tC13,6,13.8,5.9,14.6,5.9c7.6,0,11.9,8.7,11.9,8.7c-0.7,1.2-1.4,2.4-2.3,3.5 M16.9,16.9c-1.3,1.3-3.3,1.3-4.6,0\n\t\tc-1.3-1.3-1.3-3.3,0-4.6" }),
                React.createElement("path", { d: "M2.6,2.6l23.8,23.8" })))));
});
export default IconEyeClose;
//# sourceMappingURL=IconEyeClose.js.map